import { render, staticRenderFns } from "./LoginCollectedBar.vue?vue&type=template&id=62f570da&scoped=true&functional=true&"
import script from "./LoginCollectedBar.vue?vue&type=script&lang=js&"
export * from "./LoginCollectedBar.vue?vue&type=script&lang=js&"
import style0 from "./LoginCollectedBar.vue?vue&type=style&index=0&id=62f570da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "62f570da",
  null
  
)

export default component.exports